<div class="card bg-white rounded-4 w-100 p-2 shadow p-3">
  <div class="rounded-3 p-2 bg-gray d-flex justify-content-between">
    <label class="px-2 fw-semibold">{{ 'SUBSCRIPTIONS.NO' | translate }} {{ booking.bookingNo }}</label>
    <label class="px-2 fw-semibold">
      <img src="assets/icons/riyal-saudi.svg" alt="ر.س" style="height: 1em" />
      {{ booking.price }}</label
    >
  </div>
  <div class="py-3">
    <div class="row align-items-center">
      <div class="col-auto">
        <img src="assets/icons/gray-car.svg" />
      </div>

      <div class="col p-0 pb-2">
        <span class="p-1 fw-semibold d-block">{{ booking.plate }}</span>
        <p>
          <img src="assets/images/mercedes.svg" width="20px" />
          <span class="text-dark-gray fs-12">{{ booking.vehicleModel }}</span>
        </p>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-between pt-1 pb-2 border-bottom border-gray">
    <div>
      <div class="text-start fw-semibold">{{ booking.startTime }}</div>
      <div class="text-start text-dark-gray fs-12">{{ booking.startDate }}</div>
    </div>
    <div class="position-relative text-center my-3">
      <img src="assets/icons/linear-icon.svg" class="w-100" alt="line" />
      <span class="position-absolute top-50 start-50 translate-middle px-2 bg-white text-nowrap">
        {{ booking.duration }}
      </span>
    </div>
    <div>
      <div class="text-start fw-semibold">{{ booking.endTime }}</div>
      <div class="text-start text-dark-gray fs-12">{{ booking.endDate }}</div>
    </div>
  </div>
  <div class="py-2">
    <img src="assets/icons/location-pin.svg" class="pb-1" />
    <label class="px-1">{{ booking.location }}</label>
  </div>
  <div class="d-flex justify-content-between">
    <span class="text-start text-primary fw-semibold">{{ booking.timeRemaining }}</span>
    <span class="text-end bg-light-green p-1 rounded-4 px-2">{{ booking.status }}</span>
  </div>
</div>
